import { useCore } from '@/composables/core'
import { useEppo } from '@/composables/eppo'

import { useLogger } from '@booksy-com/vue-tools'
import { BILLING_METHODS, FEATURE_FLAGS } from '@/lib/consts.ts'

import { includesRoute } from '@/components/settings/subscription/helpers'
import { useDefaultRedirect } from '@/composables/default-redirect'

const logger = useLogger('router.guard.restricted-by-subscription')

export default function (route, from, next) {
  logger.debug(route.path)

  // business route
  const br = route.matched.find(r => r.name === 'business')

  // shortcut: works only for business (sub-)routes
  if (!br) {
    return next()
  }

  // allow access to the following routes when app features are restricted by business billing
  // status
  const ALLOWED_SUBSCRIPTION_ROUTES = [
    '', // subscription index route
    'your-subscription',
    'billing-details',
    'billing-details.your-billing',
    'payment-method-info', // allow display message
    'payment-method-change', // allow payment method change
    'payment-method-add', // allow payment method add
    'payment-method', // allow payment method change
    'billing-details.invoice-details', // allow invoice details change
  ]

  const ALLOWED_ROUTES = [
    'staffer-blocked-info',
    'settings-subscription-status', // allow display tablet message,
    'settings.booksy-app.delete-your-account', // allow account deletion
    'forbidden',
  ]
  const { store } = useCore()
  const defaultRedirect = useDefaultRedirect()
  const eppo = useEppo()
  const business = store.state.business?.business

  if (store.getters['business/restrictedBySubscription']
    && !(includesRoute(ALLOWED_SUBSCRIPTION_ROUTES, route.name) || ALLOWED_ROUTES.includes(route.name))
  ) {
    logger.warn(`${route.name} restricted by subscription status!`)

    if (business?.deletion_requested
      && eppo.ff(FEATURE_FLAGS.Feature_AccountDeletionViews)
      && !store.getters['identity/isOwner']
    ) {
      logger.debug('redirecting to "forbidden" (deletion_requested, non-owner)')
      return next({
        name: 'forbidden',
        params: { businessId: business.id },
        query: { reason: 'delete-requested' },
      })
    }

    if (
      store.getters['subscription/billingMethod'] === BILLING_METHODS.TABLET
      && !store.state.identity.user.access_levels.manager
    ) {
      logger.warn('redirecting to "settings-subscription-status" view via defaultRedirect...')
      return defaultRedirect()
    }

    logger.warn('redirecting to "settings.subscription" view...')
    return next({
      name: 'settings.subscription',
      params: { businessId: store.state.business.business.id },
    })
  }

  next()
}
